import { render, staticRenderFns } from "./GalasysOrderConnection.vue?vue&type=template&id=1df39846&scoped=true"
import script from "./GalasysOrderConnection.vue?vue&type=script&lang=js"
export * from "./GalasysOrderConnection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df39846",
  null
  
)

export default component.exports